<template>
  <div id="container" class="mainBox">
    <nyTit pathUrl="/agricultureRealtimeMonitorDisplay" :nextShow="true" />
    <!-- 顶部 -->
    <h5 class="h5">农田灌溉展示系统</h5>
    <!-- 左边 -->
    <div class="content">
      <div class="left">
        <div class="subTit1"><span>上蔡县5万亩高效节水灌溉示范区项目介绍</span></div>
        <div class="qx_top irrigation-top">
          <IrrigationProjectIntro />
        </div>
        <div class="irrigation-analysis">
          <div class="subTit1"> <span>灌溉计划执行、用水消耗及灌溉效率综合分析</span></div>
          <div class="irrigation-analysis-content">
            <IrrigationScheduleCalendar />
            <IrrigationWaterTrend />
            <IrrigationEfficiencyPanel />
          </div>
        </div>
      </div>
      <!--  中间-->
      <div class="center">
        <div class="subTit1">
          <span> 实时监控灌溉系统运行状态</span>
        </div>
        <div class="ggtxt irrigation-runtime-gg">
          <IrrigationRuntimeMonitor />
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right flex_column">
        <div class="subTit1"><span>智能灌溉模块</span></div>

        <div class="ggtxt flex_column">
          <!--          上部分-->
          <div class="right_left flex_wrap">
            <!--            上部分左边部分-->
            <div class="right_left_top flex_wrap_pf flex_column">
              <div class="subTit2"><span>灌溉方式及面积</span></div>
              <div class="ggtxt"><RightPie /></div>
            </div>
            <!--            上部分右边边部分-->
            <div class="flex_wrap_pf flex_column">
              <div class="ggtxt flex_column">
                <div class="subTit2"><span>视频监控</span></div>
                <div class="ggtxt">
                  <div class="videoBox1">
                    <div class="videoBg">
                      <div class="contentLine contentLine1"></div>
                      <div class="contentLine contentLine2"></div>
                      <div class="contentLine contentLine3"></div>
                      <div class="contentLine contentLine4"></div>
                      <!-- <vue3VideoPlay id="video"  ref="videoRef"  width="100%"  height="100%" title="视频监控" :src="options.src" :type="options.type" :autoPlay="true"  :muted="true" :control="false"  @loadedmetadata="onLoadedMetadata"/> -->
                      <img
                        src="../assets/img/xiaomai/video1.jpg"
                        @click="videoClick"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 下部分-->
          <div class="right_right" style="display: flex">
            <div class="ggtxt flex_column">
              <div class="subTit2"><span>数据分析</span></div>
              <div class="ggtxt flex_column">
                <div class="leftBox1Content">
                  <div class="leftBox1ContentTop">
                    <div class="circle"></div>
                    <img
                      src="../assets/img/gbzntyj/gaungai/gg.png"
                      class="circleImg"
                    />
                    <div class="leftBox1ContentTopList" v-if="state.showDiv">
                      <div
                        v-for="(item, index) in state.leftData1A"
                        :key="index"
                        class="leftBox1ContentTopItem animate__animated"
                        :class="
                          index == 0 || index == 2
                            ? 'animate__fadeInLeft'
                            : 'animate__fadeInRight'
                        "
                      >
                        <div class="contentLine contentLine1"></div>
                        <div class="contentLine contentLine2"></div>
                        <div class="contentLine contentLine3"></div>
                        <div class="contentLine contentLine4"></div>
                        <span class="txt1">{{ item.name }}</span
                        ><span class="txt2"
                      >{{ item.value }}{{ item.unit }}</span
                      >
                      </div>
                    </div>
                  </div>
                  <div class="leftBox1ContentCenter">
                    <div
                      class="dateItem"
                      :class="{ dateItemCur: state.left1Cur == index }"
                      v-for="(item, index) in state.leftData1Date"
                      :key="index"
                      @click="tabDate(dateItemCur)"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div class="leftBox1ContentBottom">
                    <div
                      class="leftBox1ContentBottom1 animate__animated animate__fadeInLeft"
                      v-if="state.showDiv"
                    >
                      <div
                        class="leftBox1ContentBottomItem"
                        v-for="(item, index) in state.leftData1B"
                        :key="index"
                      >
                        <div class="leftItem">
                          <img :src="item.icon" class="img" />
                        </div>
                        <div class="rightCon">
                          <span class="txt1">{{ item.value }}</span
                          ><span class="txt2">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ggtxt flex_column">
              <div class="subTit2"><span>灌溉总量</span></div>
              <div class="ggtxt1" style="width:100%;height: 86%"><rightLine />></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <footer1 />-->
  <popBg title="智能灌溉" :popShow="state.popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
    <div class="popInfo">
      <div class="videoBox">
        <div style="width: 100%; height: 100%" v-if="state.AccessToken != ''">
          <iframe
            :src="state.options.src + state.AccessToken"
            width="100%"
            height="100%"
            id="ysOpenDevice"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="openBtn" @click="clickOpen">
        {{ state.isOpen ? "关闭" : "打开" }}
      </div>
    </div>
  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
import leftline from "../components/Qixiang/leftline.vue";
import leftline2 from "../components/Qixiang/leftline2.vue";
import leftLine1 from "../components/Qixiang/leftLine1.vue";
import rightLine from "../components/Qixiang/rightLine.vue";
import LeftBar from "../components/Qixiang/LeftBar.vue";
import Left_fs from "../components/Qixiang/left_fs.vue";

import leftBar2 from "../components/Qixiang/leftBar2.vue";
import leftBar1 from "../components/Qixiang/leftBar1.vue";
import RightPie from "../components/Qixiang/RightPie.vue";

import nyTit from "@/components/nyTit";
import navItem from "@/components/nyNav";
import popBg from "../components/popBg.vue";
import footer1 from "../components/footer.vue";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import IrrigationProjectIntro from "@/components/farmlandIrrigationDisplay/IrrigationProjectIntro.vue";
import IrrigationScheduleCalendar from "@/components/farmlandIrrigationDisplay/IrrigationScheduleCalendar.vue";
import IrrigationWaterTrend from "@/components/farmlandIrrigationDisplay/IrrigationWaterTrend.vue";
import IrrigationEfficiencyPanel from "@/components/farmlandIrrigationDisplay/IrrigationEfficiencyPanel.vue";
import IrrigationRuntimeMonitor from "@/components/farmlandIrrigationDisplay/IrrigationRuntimeMonitor.vue";
// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const activeName = ref(0);
const state = reactive({
  fsData:[],
  leftData1: [
    ["第一季度", "第二季度", "第三季度", "第四季度"],
    [70, 30, 100, 10],
  ],
  jsleftData: [
    // ["4/18", "4/19", "4/20", "4/21","4/22", "4/23", "4/24", "4/25"],
    // [5.6, 8.9, 6, 5.8,5.6, 8.9, 6, 5.8]
  ],
  left_data1: [
    {
      sz: "20",
      name: "晴",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/q.png",
    },
    {
      sz: "20",
      name: "大风",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/f.png",
    },
    {
      sz: "20",
      name: "冰雹",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/b.png",
    },
    {
      sz: "20",
      name: "干旱",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/g.png",
    },
  ],
  left_data2: [
    {
      tx: "提醒",
      name: "未来48小时内可能有大风",
      time: "2024.4.25",
    },
    {
      tx: "提醒",
      name: "未来48小时内可能有大风",
      time: "2024.4.25",
    },
    {
      tx: "提醒",
      name: "未来48小时内可能有大风",
      time: "2024.4.25",
    },
    {
      tx: "提醒",
      name: "未来48小时内可能有大风",
      time: "2024.4.25",
    },
  ],
  leftData3: [],
  leftData1A: [
    { name: "总流量", value: "0.01", unit: "m³/h" },
    { name: "运行速度", value: "45.0", unit: "m/h" },
    { name: "水渠液位", value: "0.3", unit: "m" },
    { name: "运行时间", value: "0.3", unit: "h" },
  ],
  leftData1Date: ["3.12", "3.18", "3.24", "3.28", "4.05", "4.12", "4.16"],
  left1Cur: 0,
  leftData1B: [
    {
      name: "灌溉水量",
      value: "0.00",
      unit: "m³",
      icon: require("@/assets/img/gbzntyj/gaungai/sl.png"),
    },
    {
      name: "灌溉亩数",
      value: "0.00",
      unit: "亩",
      icon: require("@/assets/img/gbzntyj/gaungai/ms.png"),
    },
    {
      name: "亩均灌溉量",
      value: "0.00",
      unit: "m³/亩",
      icon: require("@/assets/img/gbzntyj/gaungai/pj.png"),
    },
  ],
  showDiv: true,
  leftVideo: [
    {
      options: { src: require("@/assets/video/zzng.mp4"), type: "video/mp4" },
      tabList: ["固定喷灌", "指针喷灌"],
    },
    {
      options: { src: require("@/assets/video/gg.mp4"), type: "video/mp4" },
      tabList: ["平移喷灌", "水肥一体机"],
    },
    {
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/1.mp4",
        type: "video/mp4",
      },
      tabList: ["桁架式喷灌", "卷盘式喷灌"],
    },
    {
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/11.mp4",
        type: "video/mp4",
      },
      tabList: ["平移式喷灌", "水肥一体机"],
    },
  ],
  status: 1,
  currentTime1: 0,
  laststatus: 0,
  popShow: false,
  options: {
    src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
    type: "m3u8", //视频类型
  },
  AccessToken: "",
  isOpen: false,
  weather: [
    {
      xLabel: [],
      dataValue: [],
    },
    {
      xLabel: [
        4.29, 4.3, 5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 5.1, 5.11, 5.12,
        5.13,
      ],
      dataValue: [],
    },
  ],
  curWeather: 0,
  showDiv1: true,
  zwxleftData: [],
});
function getPreviousDates(days) {
  let today = new Date();
  let previousDates = [];

  for (let i = 0; i < days; i++) {
    let date = new Date(today);
    date.setDate((today.getDate()-1) - i);
    console.log(date)
    // let month = specificDate.getMonth();
    let item = (date.getMonth()+1) + '-' +date.getDate();
    previousDates.push(item)
    // previousDates.push(date.toISOString().split('T')[0]);
  }

  return previousDates;
}
// 天气温度
function clickWd(index) {
  state.showDiv1 = false; // 点击后先隐藏div
  state.curWeather = index;
  setTimeout(() => {
    state.showDiv1 = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
function clickOpen() {
  if (!state.isOpen) {
    axios
      .get(
        "https://iot.laicunwang.com/st_change.php?id=5&type=5&status=start",
        {}
      )
      .then((res) => {
        console.log(res);
        state.isOpen = true;
        console.log("打开了", state.isOpen);
      });
  } else {
    axios
      .get(
        "https://iot.laicunwang.com/st_change.php?id=5&type=5&status=stope",
        {}
      )
      .then((res) => {
        console.log(res);
        state.isOpen = false;
        console.log("关闭了", state.isOpen);
      });
  }
}
function tabDate(index) {
  state.showDiv = false; // 点击后先隐藏div
  state.left1Cur = index;
  setTimeout(() => {
    state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
// 关闭弹出
function popHiddlen() {
  state.popShow = false;
}
// 弹出视频
function videoClick() {
  state.popShow = true;
  // state.curVideoIndex = index;
}
function getData() {
  axios
    .get("https://zhfarm.laicunwang.com/api/environment/shangcaiqxCachedata", {
      sign: "c4c6cff9b7ec6b87fa953f77ec7e624b",
    })
    .then((res) => {
      console.log(res);
      // 获取data5数据
      let data5 = res.data.data.data5;
      
      // 风速数据 - 使用data7作为数据源
      let data7 = res.data.data.data7;
      if (data7 && data7.length > 0) {
        // 格式化数据为表格所需的结构：[{time, force, direction}, ...]
        // 使用正确的字段名：day_wind_power为风力，day_wind_direction为风向
        state.fsData = data7.slice(0, 7).map(item => ({
          time: item.time || item.date || '', // 使用time字段，如果没有则回退到date
          force: item.day_wind_power || '',
          direction: item.day_wind_direction || ''
        }));
      }
      
      // 紫外线强度数据 - 使用data5-raw-day7数组下live里的uv.title
      if (data5['raw'] && data5['raw']['day7']) {
        const day7Data = data5['raw']['day7'];
        state.zwxleftData = data5.dates.slice(0, 7).map((date, index) => {
          // 获取对应的live数据中的uv.title
          const uvTitle = day7Data[index] && day7Data[index]['live'] && day7Data[index]['live']['uv'] ? 
                         day7Data[index]['live']['uv']['title'] : '';
          
          return {
            date: date,
            index: data5.weathers[index] || '',
            desc: uvTitle // 使用uv.title作为紫外线描述
          };
        });
      }
      
      // 未来7天降水预测 - 使用data5的dates和precipitations
      // 只取前7天的数据
      const jstime = data5.dates.slice(0, 7);
      const jsdata = data5.precipitations.slice(0, 7);
      
      // console.log(jsdata);
      state.jsleftData = [jstime, jsdata];
      
      // 其他数据暂时注释，等待更新
      state.leftData3[0] = res.data.data.data2.hoursResulttime.timeInfo;
      state.leftData3[1] = res.data.data.data2.HistorydataResult.soil_temperature;
      state.leftData3[2] = res.data.data.data2.HistorydataResult.soil_moisture;



      // 天气
      // 未来24小时数据 - 使用data6的hours和temps
      let weatherArr = [];
      let time = [];
      let data6 = res.data.data.data6;
      console.log(data6)
      // 只取前24小时的数据
      const hours = data6.hours.slice(0, 24);
      const temps = data6.temps.slice(0, 24);
      
      for (let i = 0; i < hours.length; i++) {
        time.push(hours[i]);
        weatherArr.push(temps[i]);
      }
      
      state.weather[0].xLabel = time;
      state.weather[0].dataValue = weatherArr;
      console.log(state.weather)

      // 未来15天数据 - 使用data5的dates和temps
      let weatherArr1 = [];
      let time1 = [];
      // 只取前15天的数据
      const dates = data5.dates.slice(0, 15);
      const temps15 = data5.temps.slice(0, 15);
      
      for (let i = 0; i < dates.length; i++) {
        time1.push(dates[i]);
        weatherArr1.push(temps15[i]);
      }
      
      state.weather[1].xLabel = time1;
      state.weather[1].dataValue = weatherArr1;
    });
}
function timeStr(timeStr, type) {
  // 将时间字符串转换为Date对象
  var date = new Date(timeStr);
  // 提取年、月、日
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  const hours = date.getHours();
  // const minutes = date.getMinutes()
  // 拼接年月日字符串
  if (type == 1) {
    var ymdStr = month + "-" + day;
  }
  if (type == 2) {
    // time: '2023-11-12 18:00',
    // var ymdStr =  year +  '-' + month + '-' + day +' '+ hours + ':00'
    var ymdStr = hours + ":00";
  }

  // 返回年月日字符串
  return ymdStr;
}
function qingxiang(data){
  let name
  if(data=="CLEAR_DAY"){name="晴"}
  if(data=="CLEAR_NIGHT"){name="晴"}
  if(data=="PARTLY_CLOUDY_DAY"){name="多云"}
  if(data=="PARTLY_CLOUDY_NIGHT"){name="多云"}
  if(data=="CLOUDY"){name="阴"}
  if(data=="LIGHT_HAZE"){name="轻度雾霾"}
  if(data=="MODERATE_HAZE"){name="中度雾霾"}
  if(data=="HEAVY_HAZE"){name="重度雾霾"}
  if(data=="LIGHT_RAIN"){name="小雨"}
  if(data=="MODERATE_RAIN"){name="中雨"}
  if(data=="HEAVY_RAIN"){name="大雨"}
  if(data=="STORM_RAIN"){name="暴雨"}
  if(data=="FOG"){name="雾"}
  if(data=="LIGHT_SNOW"){name="小雪"}
  if(data=="MODERATE_SNOW"){name="中雪"}
  if(data=="HEAVY_SNOW"){name="大雪"}
  if(data=="STORM_SNOW"){name="暴雪"}
  if(data=="DUST"){name="浮尘"}
  if(data=="SAND"){name="沙尘"}
  if(data=="WIND"){name="大风"}
  return name
}
// 在 onMounted 中初始化地图
onMounted(() => {
  state.AccessToken = localStorage.getItem("AccessToken");
  getData();
  state.leftData1Date = getPreviousDates(6);
});

onMounted(() => {
  // clearInterval(state.timer.value);
  // state.value = setInterval(() => {
  //   state.currentTime = proxy.$utils.getCurrentTime();
  // }, 1000);
});
onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
.h5{
  position: absolute;
  top: 150px;
  left: 100px;
  z-index: 999;
  font-size: 46px;
  color:#F3FCFF;
  letter-spacing: 5px;
  text-align: left;
  //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
  text-shadow:
    0 0 5px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
    0 0 10px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
    0 0 20px rgba(21, 241, 187, 1);   /* 第三层内发光 */
}
.kong {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  img {
    margin-bottom: 20px;
  }
}
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  display: flex;
  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    // border: #fff 1px solid;
    display: flex;
    padding: 0 30px 50px;
    //公共的向下布局
    .flex_column {
      display: flex;
      flex-direction: column;
    }
    .ggtxt {
      width: 100%;
      flex: 1;
      //border: 1px solid #fff;
    }
    .flex_wrap {
      display: flex;
    }
    .flex_wrap_pf {
      flex: 1;
      height: 100%;
      //border: 1px solid #fff;
    }
    .subTit1 {
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/bt.png")
        no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span {
        background: linear-gradient(to bottom, #fff 25%, #ffd791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
    }
    .subTit2 {
      width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png")
        no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254, 254, 254, 1);
    }
    .echartsBox {
      width: 100%;
      flex: 1;
    }
    .center {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 50px;
      h5 {
        font-size: 50px;
        color: #f3fcff;
        letter-spacing: 5px;
        //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
        text-shadow: 0 0 10px rgba(21, 241, 187, 0.5),
          /* 第一层内发光 */ 0 0 20px rgba(21, 241, 187, 0.8),
          /* 第二层内发光 */ 0 0 30px rgba(21, 241, 187, 1); /* 第三层内发光 */
      }
      .videoBox {
        width: 100%;
        flex: 1;
      }
      .ggtxt_top {
        width: 100%;
        height: 110px;
      }
      .irrigation-runtime-gg {
        min-height: 0;
        padding: 0 18px 18px;
        box-sizing: border-box;
      }
    }
    .left,
    .right {
      width: 2173px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      background: #071315;
    }

    .left {
      padding-left: 70px;
      padding-right: 70px;
      .qx_top {
        width: 100%;
        height: 360px;
        min-height: 0;
        display: flex;
      }

      .irrigation-top {
        display: block;
        padding: 0 20px;
        box-sizing: border-box;
      }

      .irrigation-analysis {
        width: 100%;
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
      }

      .irrigation-analysis-content {
        flex: 1;
        min-height: 0;
        display: grid;
        grid-template-columns: 1.05fr 2fr 1.05fr;
        // column-gap: 10px;
        box-sizing: border-box;
      }

      .qx_top {
        .qx_top_left {
          width: 1000px;
          height: 100%;
          .tq_tb {
            width: 185px;
            height: 185px;
            margin: 0 67px;
            //border: 1px solid #2c343c;
            display: flex;
            justify-content: center;
            align-items: center;

            .tq_xkk {
              width: 148px;
              height: 102px;
              border: 1px solid #c2e8df;
              margin-top: 25px;
              img {
                width: 70px;
                height: 62px;
              }
            }
            .tq_sz {
              width: 100%;
              flex: 1;
              color: #fff;
              font-size: 34px;
              line-height: 50px;
            }
            .tq_mz {
              width: 100%;
              height: 40px;
              color: #fff;
              font-size: 36px;
              margin-bottom: -50px;
            }
          }
        }
        .qx_top_right {
          height: 100%;
          flex: 1;
          ::v-deep .main_container{
            height: 520px;
          }
            .scroll_item{
              width: 100%;
              //height: ;
              display: flex;
              align-items: center;
              //border: 1px solid;
              margin: 30px 0;
            }
            span {
              height: 70px;
              font-size: 36px;
              line-height: 70px;
              text-align: left;
            }

            .d1 {
              width: 150px;
              background-color: rgba(197, 118, 25, 0.3);
              margin-left: 50px;
              color: #ff9023;
              text-align: center;
            }
            .d2 {
              color: #fff;
              margin: 0 50px;
            }
            .d3 {
              width: 100px;
              height: 70px;
              color: #fff;
              //margin-right: 40px;
              margin-left: 50px;
            }
          .qx_tx:nth-child(even) {
            background-color: rgba(36, 54, 62, 0.3);
          }
        }
      }
      .qx_down {
        margin-top: 15px;
        .qx_down_bt {
          width: 100%;
          height: 90px;
          display: flex;
          justify-content: center;
          align-items: center;
          .bt1 {
            width: 180px;
            height: 90px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/wl.png")
              no-repeat top center;
            background-size: 100% 100%;
            margin: 0 100px;
            color: #fff;
            font-size: 26px;
            line-height: 90px;
          }
          .cur {
            color: #00e5ed;
          }
        }
      }
    }
    .right {
      padding-right: 24px;
      display: flex;
      flex-direction: column;
      padding: 0 70px 0 30px;
      .right_left {
        height: 660px;
      }
      .right_left_top {
        width: 100%;
        height: 100%;
      }
      .right_left_down {
        width: 100%;
        flex: 1;
      }
      .rightBox1_r_top_List {
        width: 100%;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        font-size: 30px;
        justify-content: center;
        align-items: center;
        margin-top: -30px;

        .rightBox1_r_top_item {
          width: 45%;

          h6 {
            color: #fff;
            line-height: 50px;
            text-align: left;
            font-size: 26px;
            font-weight: normal;
            margin: 10px 0;
            text-indent: 3em;
          }
          .rightBox1_r_top_status {
            display: flex;
            justify-content: center;
            span {
              display: block;
              width: 128px;
              height: 50px;
              text-align: center;
              line-height: 50px;
              background: #05232e;
              color: #00798b;
              border-radius: 6px;
              font-size: 26px;
              cursor: pointer;
              margin: 0 20px;
            }
            span.isOpen {
              background: #0cb3a5;
              color: #fff;
            }
            span.isClose {
              background: #de5954;
              color: #fff;
            }
          }
        }
      }

      .leftBox1Content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: 50px;
        .leftBox1ContentTop {
          width: 66%;
          height: 239px;
          background: url("../assets/img/gbzntyj/gaungai/x.png") no-repeat
            center center;
          position: relative;
          margin: 0 auto;
          //margin: 30px 0 50px;
          .circle {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 324px;
            height: 324px;
            background: url("../assets/img/gbzntyj/gaungai/nq.png") no-repeat
              center center;
            margin: -162px 0 0 -162px;
            animation: guangying 2s linear infinite;
          }
          .circleImg {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 999;
            width: 36px;
            height: 38px;
            margin: -19px 0 0 -18px;
            animation: left1Img 2s linear infinite;
          }
          .leftBox1ContentTopList {
            width: 100%;
            height: 100%;
            position: relative;
            .leftBox1ContentTopItem {
              width: 156px;
              height: 86px;
              background: url("../assets/img/gbzntyj/gaungai/llk.png") no-repeat;
              background-size: 100% 100%;
              position: absolute;
              z-index: 999;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              line-height: 32px;
              span {
                display: block;
                font-size: 24px;
              }
              span.txt1 {
                color: #fff;
                opacity: 0.9;
              }
              span.txt2 {
                color: #00e9ef;
                font-weight: bold;
                font-size: 26px;
              }
            }
            .leftBox1ContentTopItem:nth-child(1) {
              top: -8px;
              left: 4px;
            }
            .leftBox1ContentTopItem:nth-child(2) {
              top: -8px;
              right: 6px;
            }
            .leftBox1ContentTopItem:nth-child(3) {
              bottom: -8px;
              left: 4px;
            }
            .leftBox1ContentTopItem:nth-child(4) {
              bottom: -8px;
              right: 6px;
            }
          }
        }
        .leftBox1ContentCenter {
          width: 80%;
          margin: 0 auto;
          height: 65px;
          background: url("../assets/img/gbzntyj/gaungai/rq.png") no-repeat;
          background-size: 100% 100%;
          line-height: 65px;
          padding: 0 70px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .dateItem {
            font-size: 26px;
            color: #fff;
            cursor: pointer;
          }
          .dateItem:hover,
          .dateItemCur {
            color: #ffc600;
          }
        }
        .leftBox1ContentBottom {
          width: 80%;
          margin: 0 auto;
          margin-bottom: 40px;

          height: 66px;
          .leftBox1ContentBottom1 {
            display: flex;
            width: 100%;
            height: 100%;
          }
          .leftBox1ContentBottomItem {
            flex: 1;
            display: flex;
            font-size: 26px;
            .leftItem {
              background: url("../assets/img/gbzntyj/gaungai/slk.png") no-repeat;
              width: 72px;
              height: 66px;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              .img {
                width: 35px;
                height: 35px;
                //animation: left1Img 1s linear infinite;
              }
            }
            .rightCon {
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              span {
                display: block;
                text-align: left;
                transform: perspective(1px);
              }
              span.txt1 {
                color: #00f6f8;
                font-weight: bold;
              }
              span.txt2 {
                color: #fff;
                font-style: normal;
              }
            }
          }
        }
      }
      .right_right {
        width: 100%;
        flex: 1;
      }
    }
  }
}

.videoBox1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 20px 0;

  .videoBg {
    background: url("../assets/img/gbzntyj/gaungai/spk.png") no-repeat;
    background-size: 100% 100% !important;
    width: 100%;
    height: 90%;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .videoKz {
    width: 100%;
    height: 100%;
    display: flex;
  }
}
.popInfo {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .videoBox {
    width: 100%;
    height: 100%;
  }
  .openBtn {
    position: absolute;
    left: 50%;
    bottom: 0px;
    background: url("../assets/img/xiaomai/kg.png") no-repeat;
    background-size: 100% 100%;
    width: 386px;
    height: 204px;
    z-index: 1000;
    margin-left: -193px;
    color: #fff;
    line-height: 204px;
    font-size: 30px;
  }
}

::v-deep .row-item {
  border-bottom: 1px solid;
  border-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.05) 10%,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.05)
    )
    1;
}
// 左侧1 tab

::v-deep .el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
::v-deep .el-tabs__item {
  width: 270px;
  height: 93px;
  padding: 0;
  border: 1px solid #1a6266;
  background: #0e3233;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  font-size: 34px;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 5px;
  height: 31px;
  position: absolute;
  top: 31px;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-next,
::v-deep .el-tabs__nav-prev {
  font-size: 60px;
  line-height: 110px;
  width: 50px;
  font-weight: bold;
}
::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0 70px;
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 0px;
  left: 0;
  width: 10%;
  height: 1px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 1px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: -1px;
  right: -100%;
  width: 20%;
  height: 1px;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 0px;
  width: 1px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 4px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 4px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 4px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(0.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
